import { render, staticRenderFns } from "./AddFeeCompanyComponent.vue?vue&type=template&id=28768d7b&"
import script from "./AddFeeCompanyComponent.vue?vue&type=script&lang=js&"
export * from "./AddFeeCompanyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports